import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Eye, Edit, Trash2 } from 'lucide-react';
import { COLUMNAS, PRIORIDADES } from '@/utils/tareaUtils';

export default function VistaLista({ tareas, onEdit, onDelete, onViewDetail }) {
  return (
    <Card>
      <CardContent className="pt-6">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Título</TableHead>
              <TableHead>Estado</TableHead>
              <TableHead>Prioridad</TableHead>
              <TableHead>Responsable</TableHead>
              <TableHead>Lote</TableHead>
              <TableHead>Fecha</TableHead>
              <TableHead>Acciones</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {tareas.map(tarea => {
              const prioridad = PRIORIDADES[tarea.prioridad];
              const estadoCol = COLUMNAS.find(c => c.id === tarea.estado);
              return (
                <TableRow key={tarea.id}>
                  <TableCell className="font-medium">{tarea.titulo}</TableCell>
                  <TableCell>
                    <Badge className={estadoCol.color}>{estadoCol.titulo}</Badge>
                  </TableCell>
                  <TableCell>
                    <Badge className={prioridad.color}>
                      {prioridad.icon} {prioridad.label}
                    </Badge>
                  </TableCell>
                  <TableCell>{tarea.responsable_nombre || '-'}</TableCell>
                  <TableCell>{tarea.lote_nombre || '-'}</TableCell>
                  <TableCell>{tarea.fecha_planificada || '-'}</TableCell>
                  <TableCell>
                    <div className="flex gap-1">
                      <Button size="sm" variant="ghost" onClick={() => onViewDetail(tarea)}>
                        <Eye className="w-4 h-4" />
                      </Button>
                      <Button size="sm" variant="ghost" onClick={() => onEdit(tarea)}>
                        <Edit className="w-4 h-4" />
                      </Button>
                      <Button size="sm" variant="ghost" className="text-red-600" onClick={() => onDelete(tarea.id)}>
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
